<form class="or-form or-form-schedule" [formGroup]="form">
  <div class="or-form-items">
    <div>
      <mat-form-field>
        <mat-label>Schedule Name</mat-label>
        <input matInput type="text" maxlength="64" formControlName="name" data-cy="schedule-name-input" />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance='fill' class='schedule-form-date'>
        <mat-label>Start Date</mat-label>
        <input
          matInput
          [min]="minSelectableStartDate"
          [placeholder]="'DD/MM/YYYY'"
          formControlName="startDate"
          [matDatepicker]='startDatepicker'
          (dateChange)="onChangeStartDate()">
        <mat-datepicker-toggle matSuffix [for]='startDatepicker'></mat-datepicker-toggle>
        <mat-datepicker #startDatepicker></mat-datepicker>
        @if (startDate?.errors?.required || startDate?.errors?.matDatepickerMin) {
        <mat-error data-cy="start-date-error">
          {{ startDate?.errors?.required ? 'Start date is required' : 'Start date cannot be in the past' }}
        </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="pt-4 pb-4">
      <mat-label class="or-label">Select Days :</mat-label>
      <div class="or-inline-items or-days-of-week" formArrayName="days">
        @for(day of daysOfTheWeekControl; track $index) {
          <span class="or-inline-item or-day-of-week">
            <button (click)="setDays($index)" class="or-button or-day-of-week-toggle"
                    [attr.data-cy]="'day-of-the-week-'+ $index"
                    [ngClass]='{ "or-active": schedule.days.isActive($index+1)}'>
                <input type="checkbox" [formControl]="day" hidden>
              {{daysOfTheWeek[$index].shortName()}}
            </button>
          </span>
        }
      </div>
    </div>
    <div class="space-x-4 flex flex-row items-center">
      <mat-slide-toggle data-cy="start-solar-events-toggle" color="primary" (change)="onStartSolarEventsToggle()" formControlName="isStartSolarEvent">Start with Solar Events</mat-slide-toggle>
      @if(!form.value.isStartSolarEvent){
        <mat-form-field class="ml-4">
          <mat-label class="or-label">Start Time</mat-label>
          <mat-select formControlName="startTime" (selectionChange)="updateStartTime()" data-cy="start-time-dropdown">
            @for(time of times; track $index) {
              <mat-option [value]="time">{{ time }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      } @else {
        <mat-form-field appearance='fill' class="ml-4">
          <mat-label>Event</mat-label>
          <mat-select data-cy="start-solar-events-dropdown"
            [ngClass]="'mat-select-arrow'"
            formControlName='startSolarEvent'
            (selectionChange)="onChangeStartSolarEvent()">
            @for (event of solarEventOptions; track event) {
              <mat-option [value]='event.value'>{{event.label}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field  appearance='fill'>
          <mat-label>Offset Start Time</mat-label>
          <mat-select data-cy="offset-start-time-dropdown"
            [ngClass]="'mat-select-arrow'"
            formControlName='offsetStartTime'
            (selectionChange)="onChangeOffsetStartTime()">
            <mat-option [value]="atSameTime.time">{{ atSameTime.label }}</mat-option>
            <mat-optgroup label="Before">
            @for(time of offsetBeforeTimes; track $index) {
                <mat-option [value]="time.time">{{ time.label }}</mat-option>
            }
            </mat-optgroup>
            <mat-optgroup label="After">
              @for(time of offsetAfterTimes; track $index) {
                  <mat-option [value]="time.time">{{ time.label }}</mat-option>
              }
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
      }
    </div>
    <div class="space-x-4 flex flex-row items-center">
      <mat-slide-toggle data-cy="end-solar-events-toggle" color="primary" (change)="onEndSolarEventsToggle()" formControlName="isEndSolarEvent">Ends with Solar Events</mat-slide-toggle>
      @if(!form.value.isEndSolarEvent) {
        <mat-form-field class="ml-4">
          <mat-label class="or-label">End time</mat-label>
          <mat-select formControlName="endTime" (selectionChange)="updateEndTime()" data-cy="end-time-dropdown">
            @for(time of times; track $index) {
              <mat-option [value]="time">{{ time }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      } @else {
        <mat-form-field appearance='fill' class="ml-4">
          <mat-label>Event</mat-label>
          <mat-select data-cy="end-solar-events-dropdown"
            [ngClass]="'mat-select-arrow'"
            formControlName='endSolarEvent'
            (selectionChange)="onChangeEndSolarEvent()">
            @for (event of solarEventOptions; track event) {
              <mat-option [value]='event.value' [disabled]="form.get('startSolarEvent').value === 'SUNSET' && event.value === 'SUNRISE'">{{event.label}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field  appearance='fill'>
          <mat-label>Offset End Time</mat-label>
          <mat-select data-cy="offset-end-time-dropdown" [ngClass]="'mat-select-arrow'"
                      formControlName='offsetEndTime'
                      (selectionChange)="onChangeOffsetEndTime()">
            <mat-option [value]="atSameTime.time">{{ atSameTime.label }}</mat-option>
            <mat-optgroup label="Before">
              @for(time of offsetBeforeTimes; track $index) {
                <mat-option [value]="time.time">{{ time.label }}</mat-option>
              }
            </mat-optgroup>
            <mat-optgroup label="After">
              @for(time of offsetAfterTimes; track $index) {
                <mat-option [value]="time.time">{{ time.label }}</mat-option>
              }
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
      }
    </div>

  </div>
  <div class="pt-4 pb-4 or-form-title"><h2>Rules</h2></div>
  @if(schedule.rules?.length == 0) {
    <app-notification-block
      [header]="'No rules for schedule!'"
      [statusClass]="StatusClass.ERROR"
      [showButton]="true"
      (buttonAction)="addRule()"
      [buttonText]="'Add Rule'">
      This schedule doesn't have any rules yet. Please add at least one rule before saving.
    </app-notification-block>
  } @else  {
    <div class="pb-2">
      @for(rule of schedule.rules; track $index) {
        <div class="or-form-schedule-ruleset-rule" >
          <app-schedule-rule
            [buildingId]="building.id"
            [active]="schedule.active"
            [rule]="rule"
            (onRemoveRule)="removeRule($index)"
            (onChange)="validateRules()"></app-schedule-rule>
        </div>
      }
      <div class="bottom-border pb-4">
        <button
          mat-raised-button
          matTooltip="Add another rule"
          (click)="addRule()"
          data-cy="add-another-rule-button">
          <mat-icon class="text-xl-center" fontIcon="add_circle" />
          <span class="text-lg">{{ 'Add another rule' }}</span>
        </button>
      </div>
    </div>
  }
  @if (!validateWeekDayTimeSchedule && ((isNew && startControlDirty && endControlsDirty) || (!isNew && (startControlDirty || endControlsDirty)))) {
    <mat-error data-cy="schedule-form-error">
      @if(startSolarEvent.value === 'SUNSET' && endSolarEvent.value === 'SUNSET') {
        Start and end solar events are both SUNSET. Please adjust offset values!
      } @else if(startSolarEvent.value === 'SUNRISE' && endSolarEvent.value === 'SUNRISE') {
        Start and end solar events are both SUNRISE. Please adjust offset values!
      } @else {
        End date and time must be after start date and time!
      }
    </mat-error>
  }
  <div class="flex flex-row w-full space-x-4 pt-4">
    <button
      mat-raised-button
      matTooltip="Save Schedule"
      color="primary"
      (click)="save()"
      [disabled]="form.invalid || !validateRules() || !validateActiveWeekDays || !validateWeekDayTimeSchedule || !validateStartSolarEventSelected || !validateEndSolarEventSelected"
      data-cy="save-schedule-button">
      <mat-icon class="text-xl-center" fontIcon="task_alt" />
      <span class="text-lg">{{saveLabel}}</span>
    </button>
    <button
      mat-raised-button
      matTooltip="Reset and Close"
      (click)="close()"
      data-cy="reset-and-close-schedule-button">
      <mat-icon class="text-xl-center">refresh</mat-icon>
      <span class="text-lg">Reset and Close</span>
    </button>
    @if (!isNew) {
      <button
        class="delete"
        mat-raised-button
        matTooltip="Delete Schedule"
        (click)="delete()"
        data-cy="delete-schedule-button">
        <mat-icon class="text-xl-center">delete</mat-icon>
        <span class="text-lg">Delete</span>
    </button>
    }
  </div>
</form>
